import { filter } from 'lodash';
import Message from 'src/app/models/message';
import { MessageService } from './../../services/message.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { Subscription} from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { CoreService } from 'src/app/services/core.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SpinnerOverlayService } from 'src/app/services/spinnerOverlay.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@UntilDestroy()
@Component({
  selector: 'auth',
  templateUrl: 'auth.component.html',
  styleUrls: [],
  providers: [UserService]
})
export class AuthComponent implements OnInit {
  isAuthorizedSubscription: Subscription;
  messages: Message[];
  constructor(
    public oidcSecurityService: OidcSecurityService,
    private router: Router,
    private userService: UserService,
    private coreService: CoreService,
    private messageService: MessageService,
    private spinnerOverlayService: SpinnerOverlayService,
    private route: ActivatedRoute,
    private authService: AuthService
    ) {
  }

  ngOnInit(): void {
    this.spinnerOverlayService.show();

    this.route.queryParams.pipe(untilDestroyed(this)).subscribe((q) => {
      if (q.logOffAndRevoke) {
        this.authService.logout();
      }
    });

    this.messageService.getMessages().pipe(untilDestroyed(this)).subscribe((messages: Message[]) => {
      this.messages = filter(messages, (message: Message) => message.isActive && message.moduleObject['Login Page']);
      this.spinnerOverlayService.hide();
    });
  }
}
